export { DMS_MODULE } from '../constants';
export const NAME = 'DetailsOfItemsTransfer';
export const API_NAME = 'ItemsTransferDetail';
export const CRUMB_LABEL_KEY = 'DetailsOfItemsTransfer';
export const EXPORT_FILE_NAME = 'DetailsOfItemsTransfer.xlsx';
export const addFirstYearMonthDate = 1;
export const subtractOneYear = 365;

export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };
